import { Box, Typography, Button, Container } from '@mui/material';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { Link } from 'react-router-dom';

const PaymentReject = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <Container maxWidth='sm' sx={{ textAlign: 'center', padding: 4 }}>
        <BlockOutlinedIcon
          sx={{
            fontSize: '100px',
            color: '#ff9800',
            marginBottom: 2,
          }}
        />
        <Typography
          variant='h4'
          gutterBottom
          sx={{ fontWeight: 'bold', color: '#ff9800' }}
        >
          Transaction Cancel
        </Typography>
        <Typography
          variant='body1'
          sx={{
            marginBottom: 3,
            color: '#6c757d',
          }}
        >
          Unfortunately, your transaction was cancelled.
        </Typography>
        <Link to={'/new-member-applications'}>
          <Button
            variant='contained'
            color='warning'
            size='large'
            sx={{
              padding: '10px 30px',
              borderRadius: '30px',
              textTransform: 'none',
              fontSize: '16px',
            }}
          >
            Retry Transaction
          </Button>
        </Link>
      </Container>
    </Box>
  );
};

export default PaymentReject;
